import { Component, OnDestroy, OnInit } from '@angular/core';
import { Router } from '@angular/router';
import { Subscription } from 'rxjs/Subscription';
import { JackpotService } from '@app/core/jackpot.service';
import { SoundsService } from '@app/core/sounds.service';
import * as amplitude from 'amplitude-js';

@Component({
  selector: 'app-open-chest-modal',
  templateUrl: './open-chest-modal.template.html',
  styleUrls: ['./open-chest-modal.template.scss'],
  animations: [],
})
export class OpenChestNewModalComponent implements OnInit, OnDestroy {
  jackpotUserInfo$: Subscription = null;
  chests: number = 0;
  keys: number = 0;
  _loading: boolean = false;
  keysReceived: number = 0;

  opened: number = 0;

  openAll: boolean = false;

  timeout: any = null;

  openChest: boolean = false;

  public sounds: any = [
    {
      name: 'open',
      path: 'assets/sounds/chest/open.mp3',
    },
  ];

  constructor(
    private jackpotService: JackpotService,
    private router: Router,
    private soundsService: SoundsService,
  ) {}

  public ngOnInit() {
    this.jackpotUserInfo$ = this.jackpotService.info$.subscribe((data: any) => {
      if (data) {
        this.chests = data.chests;
        this.keys = data.keys.length;
      }
    });
    this.soundsService.init(this.sounds);
  }

  public ngOnDestroy() {
    if (this.jackpotUserInfo$) {
      this.jackpotUserInfo$.unsubscribe();
    }

    if (this.timeout) {
      clearTimeout(this.timeout);
    }

    this.jackpotService.getAuthInfo();

    this.openAll = false;
  }

  public openJackpotChest() {
    if (this.openChest || this.chests === 0 || this._loading) {
      return;
    }
    this._loading = true;
    this.jackpotService
      .openChest()
      .then((data: any) => {
        this.opened++;
        this._loading = false;
        this.keysReceived = data.keys.length;

        amplitude.getInstance().logEvent('Jackpot - Open Chest', {
          'Keys Received': this.keysReceived,
        });

        this.openChestAnimation();
      })
      .catch((error: any) => {
        this._loading = false;
      });
  }

  openChestAnimation() {
    if (this.openChest || this.chests === 0) {
      return;
    }
    this.openChest = true;
    this.soundsService.play('open');

    this.timeout = setTimeout(() => {
      this.addKeys(this.keysReceived);
    }, 5000);
  }

  public openAllJackpotChests() {
    /*if (this.openAll) {
      this.openAll = false;
      return;
    }*/
    if (this.openChest || this.chests === 0 || this._loading) {
      return;
    }
    this._loading = true;
    this.openAll = true;
    this.jackpotService
      .openChest()
      .then((data: any) => {
        this.opened++;
        this._loading = false;
        this.keysReceived = data.keys.length;

        amplitude.getInstance().logEvent('Jackpot - Open Chest', {
          'Keys Received': this.keysReceived,
        });

        // this.openChestAnimation();
        this.soundsService.play('open');
        this.addKeys(this.keysReceived);
      })
      .catch((error: any) => {
        this._loading = false;
      });
  }

  addKeys(add: number) {
    if (add > 0) {
      this.keys++;
      setTimeout(() => {
        this.addKeys(add - 1);
      }, 100);
    } else {
      this.jackpotService.getAuthInfo().then(() => {
        this.openChest = false;
        if (this.openAll) {
          this.openAllJackpotChests();
        }
      });
    }
  }
}



// WEBPACK FOOTER //
// /var/lib/jenkins/workspace/Prod_web-client/src/app/_v2/template/modals/open-chest-new/open-chest-modal.component.ts